import React from 'react';

import UpstreamTable from '../../../../../components/Table/UpstreamTable';

const Upstream: React.FC<{
  selectedYear: string;
  facilityId: string;
}> = ({selectedYear, facilityId}) => {
  return <UpstreamTable facilityId={facilityId} selectedYear={selectedYear} />;
};

export default Upstream;
